if (!customElements.get('cart-progress')) {
    class cartProgress extends HTMLElement {
      constructor() {
        super();
  
        this.cartTotal = parseFloat(this.dataset.cartTotal);
        this.freeShipPrice = this.dataset.freeshipPrice;
        this.progressBar = this.querySelector(' .progress-bar');
        this.progressHeader = this.querySelector('.progress-bar-header');
  
        this.offerOnePrice = this.dataset.offerOne;
        this.offerTwoPrice = this.dataset.offerTwo;
  
        this.offerZeroText = this.dataset.freeshipPriceText;
        this.offerOneText = this.dataset.offerOneText;
        this.offerTwoText = this.dataset.offerTwoText;

        this.init();
      }
  
      

      initProgressBar = () => {

            // step 1
            let progressBarWidthZero = 0;
            if (this.freeShipPrice != '') {
                progressBarWidthZero = (parseInt(this.freeShipPrice)  - this.cartTotal) / parseInt(this.freeShipPrice) * 100;
                progressBarWidthZero = 100 - progressBarWidthZero;
                if(progressBarWidthZero >= 100) progressBarWidthZero = 100;
                  this.querySelector('[data-mileston-zero]').style.setProperty('--progress',`${progressBarWidthZero.toFixed(2)}%`);
                  this.querySelector('[data-mileston-zero]').style.setProperty('--firstLeft',`${progressBarWidthZero.toFixed(2)}%`);
              if(progressBarWidthZero >= 100) progressBarWidthZero = 100;
              }
            
            // step 2
            let progressBarWidthOne = 0;
            if (this.offerOnePrice != '') {
                progressBarWidthOne = (parseInt(this.offerOnePrice)  - this.cartTotal) / parseInt(this.offerOnePrice) * 100;
                progressBarWidthOne = 100 - progressBarWidthOne;
              if(progressBarWidthOne >= 100) progressBarWidthOne = 100;
              (progressBarWidthOne >= 100) ? this.querySelector('[data-mileston-one]').classList.add('filled') : this.querySelector('[data-mileston-one]').classList.remove('filled') ;
              if (this.freeShipPrice != '') { 
                if (progressBarWidthZero >= 100) {
                  this.querySelector('[data-mileston-one]').style.setProperty('--progress',`${progressBarWidthOne.toFixed(2)}%`);
                } else {
                  this.querySelector('[data-mileston-one]').style.setProperty('--progress',`0`);
                }
              }
              else {
                  this.querySelector('[data-mileston-one]').style.setProperty('--progress',`${progressBarWidthOne.toFixed(2)}%`);
                  this.querySelector('[data-mileston-one]').style.setProperty('--firstLeft',`${progressBarWidthOne.toFixed(2)}%`);
              }
            }
  
            // step 3
            let progressBarWidthTwo = 0;
            if (this.offerTwoPrice != '') {
              progressBarWidthTwo = (this.offerTwoPrice  - this.cartTotal) / this.offerTwoPrice * 100;
              progressBarWidthTwo = 100 - progressBarWidthTwo;
              if(progressBarWidthTwo >= 100) progressBarWidthTwo = 100;
              (progressBarWidthTwo >= 100) ? this.querySelector('[data-mileston-two]').classList.add('filled') : this.querySelector('[data-mileston-two]').classList.remove('filled') ;
              if (this.freeShipPrice != '' && this.offerOnePrice == '') { 
                if (progressBarWidthZero >= 100) {
                  this.querySelector('[data-mileston-two]').style.setProperty('--progress',`${progressBarWidthTwo.toFixed(2)}%`); 
                } else {
                  this.querySelector('[data-mileston-two]').style.setProperty('--progress',`0`); 
                }
              }
              else if (this.offerOnePrice != '') { 
                if (progressBarWidthOne >= 100) {
                  this.querySelector('[data-mileston-two]').style.setProperty('--progress',`${progressBarWidthTwo.toFixed(2)}%`); 
                } else {
                  this.querySelector('[data-mileston-two]').style.setProperty('--progress',`0`); 
                }
              }
              else {
                  this.querySelector('[data-mileston-two]').style.setProperty('--progress',`${progressBarWidthTwo.toFixed(2)}%`);
                  this.querySelector('[data-mileston-two]').style.setProperty('--firstLeft',`${progressBarWidthTwo.toFixed(2)}%`);
              }
            }
  
            // show remaining ammout text
            if (this.offerTwoPrice != '' && this.offerOnePrice != '' && this.freeShipPrice != '') { 
              if (progressBarWidthZero < 99.99) {
                let remainingPrice = (this.freeShipPrice - this.cartTotal) * 100;
                remainingPrice = theme?.Currency.formatMoney(remainingPrice, theme?.settings.moneyFormat);
                this.progressHeader.innerHTML = `You are <strong>${remainingPrice}</strong> away from a <strong>${this.offerZeroText}</strong>`; 
              } else if (progressBarWidthZero > 99.99 && progressBarWidthOne < 99.99) {
                let remainingPrice = (parseInt(this.offerOnePrice) - this.cartTotal) * 100;
                remainingPrice = theme?.Currency.formatMoney(remainingPrice, theme?.settings.moneyFormat);
                this.progressHeader.innerHTML = `You are <strong>${remainingPrice}</strong> away from a <strong>${this.offerOneText}</strong>`; 
              } else if (progressBarWidthOne > 99.99 && progressBarWidthTwo < 99.99) {
                let remainingPrice = (this.offerTwoPrice - this.cartTotal) * 100;
                remainingPrice = theme?.Currency.formatMoney(remainingPrice, theme?.settings.moneyFormat);
                this.progressHeader.innerHTML = `You are <strong>${remainingPrice}</strong> away from a <strong>${this.offerTwoText}</strong>`; 
              } else {
                this.progressHeader.innerHTML = `Congrats!✨ You've unlocked <strong>${this.offerTwoText}</strong>`; 
              }
            }
            else if (this.offerTwoPrice == '' && this.offerOnePrice != '' && this.freeShipPrice == '') {
              if (progressBarWidthOne < 99.99) {
                let remainingPrice = (parseInt(this.offerOnePrice) - this.cartTotal) * 100;
                remainingPrice = theme.Currency.formatMoney(remainingPrice, theme?.settings.moneyFormat);
                this.progressHeader.innerHTML = `Add more <strong>${remainingPrice}</strong> to get <strong>${this.offerOneText}</strong>`; 
              } else {
                this.progressHeader.innerHTML = `Congrats!✨ You've unlocked <strong>${this.offerOneText}</strong>`; 
              }
            }
            else if (this.offerTwoPrice != '' && this.offerOnePrice == '' && this.freeShipPrice == '') {
              if (progressBarWidthTwo < 99.99) {
                let remainingPrice = (this.offerTwoPrice - this.cartTotal) * 100;
                remainingPrice = theme?.Currency.formatMoney(remainingPrice, theme?.settings.moneyFormat);
                this.progressHeader.innerHTML = `Add more <strong>${remainingPrice}</strong> to get <strong>${this.offerTwoText}</strong>`; 
              } else {
                this.progressHeader.innerHTML = `Congrats!✨ You've unlocked <strong>${this.offerTwoText}</strong>`; 
              }
            }
            else if (this.offerOnePrice == '' && this.offerTwoPrice != '' && this.freeShipPrice != '') {
              if (progressBarWidthZero < 99.99) {
                let remainingPrice = (this.freeShipPrice - this.cartTotal) * 100;
                remainingPrice = theme?.Currency.formatMoney(remainingPrice, theme?.settings.moneyFormat);
                this.progressHeader.innerHTML = `You are <strong>${remainingPrice}</strong> away from a <strong>${this.offerZeroText}</strong>`; 
              } else if (progressBarWidthZero > 99.99 && progressBarWidthTwo < 99.99) {
                let remainingPrice = (parseInt(this.offerTwoPrice) - this.cartTotal) * 100;
                remainingPrice = theme?.Currency.formatMoney(remainingPrice, theme?.settings.moneyFormat);
                this.progressHeader.innerHTML = `You are <strong>${remainingPrice}</strong> away from a <strong>${this.offerTwoText}</strong>`; 
              } else {
                this.progressHeader.innerHTML = `Congrats!✨ You've unlocked <strong>${this.offerTwoText}</strong>`; 
              }
            }
            else if (this.offerOnePrice != '' && this.offerTwoPrice != '' && this.freeShipPrice == '') {
              if (progressBarWidthOne < 99.99) {
                let remainingPrice = (this.offerOnePrice - this.cartTotal) * 100;
                 remainingPrice = theme?.Currency.formatMoney(remainingPrice, theme?.settings.moneyFormat);
                this.progressHeader.innerHTML = `You are <strong>${remainingPrice}</strong> away from a <strong>${this.offerOneText}</strong>`; 
              } else if (progressBarWidthOne > 99.99 && progressBarWidthTwo < 99.99) {
                let remainingPrice = (parseInt(this.offerTwoPrice) - this.cartTotal) * 100;
                 remainingPrice = theme?.Currency.formatMoney(remainingPrice, theme?.settings.moneyFormat);
                this.progressHeader.innerHTML = `You are <strong>${remainingPrice}</strong> away from a <strong>${this.offerTwoText}</strong>`; 
              } else {
                this.progressHeader.innerHTML = `Congrats!✨ You've unlocked <strong>${this.offerTwoText}</strong>`; 
              }
            }
            else if (this.offerOnePrice != '' && this.offerTwoPrice == '' && this.freeShipPrice != '') {
              if (progressBarWidthZero < 99.99) {
                let remainingPrice = (this.freeShipPrice - this.cartTotal) * 100;
                 remainingPrice = theme?.Currency.formatMoney(remainingPrice, theme?.settings.moneyFormat);
                this.progressHeader.innerHTML = `You are <strong>${remainingPrice}</strong> away from a <strong>${this.offerZeroText}</strong>`; 
              } else if (progressBarWidthZero > 99.99 && progressBarWidthOne < 99.99) {
                let remainingPrice = (parseInt(this.offerOnePrice) - this.cartTotal) * 100;
                 remainingPrice = theme.Currency.formatMoney(remainingPrice, theme?.settings.moneyFormat);
                this.progressHeader.innerHTML = `You are <strong>${remainingPrice}</strong> away from a <strong>${this.offerOneText}</strong>`; 
              } else {
                this.progressHeader.innerHTML = `Congrats!✨ You've unlocked <strong>${this.offerOneText}</strong>`; 
              }
            }
             else {
              if (progressBarWidthZero < 99.99) {
                let remainingPrice = (this.freeShipPrice - this.cartTotal) * 100;
                 remainingPrice = theme.Currency.formatMoney(remainingPrice, theme.settings.moneyFormat);
                this.progressHeader.innerHTML = `Add more <strong>${remainingPrice}</strong> to get <strong>${this.offerZeroText}</strong>`; 
              } else {
                this.progressHeader.innerHTML = `Congrats!✨ You've unlocked <strong>${this.offerZeroText}</strong>`; 
              }
            }
      }
  
      updateQuickCartTotal = () => {
        this.addcartEle = document.querySelector('.discount_subtotal_sticky [data-total-cart-price]');
              if (this.addcartEle) { 
                  this.cartUpdateChangeMutation = new MutationObserver(() => {
            const priceStr1 = document.querySelector('.discount_subtotal_sticky [data-total-cart-price]').textContent;
            this.totalPrice = parseInt(priceStr1.replace('₹','').replace('USD','').replace(' ','').replace(',',''));
            this.cartTotal = this.totalPrice;
            this.initProgressBar();
            setTimeout(() => {
              this.completeBar();
          }, 1000); 
            if (this.totalPrice <= 0) {
              this.style.display = 'none';
            } else {
              this.style.display = null;
            }
                  });
                  this.cartUpdateChangeMutation.observe(this.addcartEle, {childList:true,attributes:true})
              }
  
      }
   completeBar = () => {
                         // Select all elements with the attribute "data-mileston-zero"
        const progressIndicators = document.querySelectorAll('[data-mileston-zero]');

        // Initialize a variable to track completeness
        let allComplete = true;

        // Iterate over each progress indicator
        progressIndicators.forEach(indicator => {
          const style = indicator.getAttribute('style');

          // Check if the style attribute contains the "--progress" declaration
          if (style && style.includes('--progress')) {
            const progress = parseFloat(style.match(/--progress: ([^%;]+)/)[1]);
            if (progress !== 100) {
              allComplete = false;
              return; // Exit loop early if any progress is not 100%
            }
          } else {
            // If the "--progress" declaration is not found, consider it incomplete
            allComplete = false;
          }
        });

        // Check the overall completeness
        if (allComplete) {
          console.log("All CSS progress is at 100%.");
          const progressBarWrapper = document.querySelector('.progress-bar-wrapper');
          if (progressBarWrapper) {
            progressBarWrapper.classList.add('complete');
          }
        } else {
          console.log("Not all CSS progress is at 100%.");
        }
      const accordionIcons = document.querySelector('.accordion__label-icons');
            const accordionContent = document.querySelector('.acco-content');

            accordionIcons?.addEventListener('click', () => {
              accordionIcons.classList.toggle('active');
              var Icon = accordionIcons.querySelector('.icon-plus');
              if (accordionIcons.classList.contains('active')) {
                Icon.style.display = 'block';
              } else {
                Icon.style.display = 'none';

              }
             
              
              accordionContent.classList.toggle('active');
            });
    }

    discountCopy = () => {
        // discount-code js
        document.querySelectorAll('.success-msg-main').forEach(success => {
        success.style.display="none";
        })
        // document.querySelectorAll('.discount-code-desc-inner').forEach(offer => {
        //     offer.addEventListener('click', (e) => {
        //         var current = e.currentTarget;
        //         var nextcurrent = e.currentTarget.nextElementSibling;
        //         var loaderclass = e.currentTarget.previousElementSibling;
        //         var discount_code = e.currentTarget.getAttribute('data-id');
        //         loaderclass.style.display = "flex";
        //         current.style.display="none";
        //         fetch(`/discount/${discount_code}`,{
        //         method: 'GET',
        //         })
        //         .then(response => {
        //             loaderclass.style.display="none";
        //             current.style.display = "none";
        //             nextcurrent.style.display = "flex";
        //             setTimeout(function() {
        //                 current.style.display = "block";
        //                 nextcurrent.style.display = "none";
        //             }, 4000);
        //         })
        //     })
        // })
    }
      init = () => {
        this.initProgressBar();
        // this.updateCartTotal();
        this.updateQuickCartTotal();
        this.discountCopy();
        setTimeout(() => {
          this.completeBar();
      }, 1000); 
      }
    }
    customElements.define('cart-progress',cartProgress);
  }